export default "__VITE_ASSET__Bk6874MG__"